import { createSlice } from '@reduxjs/toolkit';

import { appService } from 'services';

/**
 * @function initialState
 * @returns {StepState}
 */

const initialState = () => {
  const initialSteps = appService.isTouloisirs() ? ['statusStep'] : ['otherUserInfoStep'];
  return {
    steps: initialSteps,
    autolog: '' // 'success' | 'failed' | ''
  };
};

export const authReducer = createSlice({
  name: 'auth',
  initialState: { ...initialState() },
  reducers: {
    addStep: (state, action) => {
      const newStep = action.payload;
      return { ...state, steps: [...state.steps, newStep] };
    },
    popStep: (state) => {
      const newSteps = state.steps.slice(0, -1);
      return { ...state, steps: newSteps };
    },
    setAutolog: (state, action) => {
      state.autolog = action.payload;
    },
    resetAuthStore: (state) => {
      Object.assign(state, initialState());
    },
    resetSteps: (state) => {
      return { ...state, steps: initialState().steps };
    }
  }
});

export const { addStep, popStep, resetAuthStore, setAutolog, resetSteps } = authReducer.actions;

export default authReducer.reducer;
